"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Theme_1 = require("./Theme");
exports.default = Theme_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/theme/lib/index.js
// module id = ./node_modules/@react-mdc/theme/lib/index.js
// module chunks = 2